var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHbdocpredict(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hbdocpredict",
    xmlns: "http://www.w3.org/2000/svg",
    width: 170.243,
    height: 43.6,
    viewBox: "0 0 170.243 43.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo-Predict"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo-Approve"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9",
    d: "M43.5,25.9V39.8a3.8,3.8,0,0,1-3.8,3.8H3.8A3.952,3.952,0,0,1,0,39.7V25.9H43.5Z",
    fill: "#064b93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10",
    d: "M43.5,4.3V25.8H0V4.3A4.268,4.268,0,0,1,4.3,0H39.1a4.291,4.291,0,0,1,4.4,4.3Z",
    fill: "#03968f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "AP"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_46",
    "data-name": "Groupe 46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1371",
    "data-name": "Trac\\xE9 1371",
    d: "M17.038,29.751A3.1,3.1,0,0,1,18.267,30a3.179,3.179,0,0,1,1.007.676,3.259,3.259,0,0,1,.683,1.008,3.028,3.028,0,0,1,.253,1.229,3.061,3.061,0,0,1-.253,1.241,3.242,3.242,0,0,1-.683,1.008,3.191,3.191,0,0,1-1.007.676,3.091,3.091,0,0,1-1.229.247H14.672v2.756H13.45V29.752h3.588Zm0,5.135a1.834,1.834,0,0,0,.754-.156,2.027,2.027,0,0,0,.617-.422,1.928,1.928,0,0,0,.416-.624,1.976,1.976,0,0,0,.15-.773,1.949,1.949,0,0,0-.15-.761,1.917,1.917,0,0,0-.416-.624,2.048,2.048,0,0,0-.617-.423,1.834,1.834,0,0,0-.754-.155H14.672v3.938Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1372",
    "data-name": "Trac\\xE9 1372",
    d: "M28.92,32.611a2.758,2.758,0,0,1-.195,1.033,2.959,2.959,0,0,1-.527.864,2.812,2.812,0,0,1-.787.624,2.93,2.93,0,0,1-.975.325l2.47,3.38H27.385l-2.457-3.354H23.381v3.354H22.159v-9.1h3.887a2.748,2.748,0,0,1,1.111.228A2.888,2.888,0,0,1,28.692,31.5a2.79,2.79,0,0,1,.228,1.112Zm-2.873,1.677a1.611,1.611,0,0,0,1.17-.487,1.665,1.665,0,0,0,.345-.533,1.8,1.8,0,0,0,0-1.313,1.633,1.633,0,0,0-.345-.532,1.607,1.607,0,0,0-1.17-.488H23.382v3.354h2.665Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11",
    d: "M.3,15.812l22-15.5h6l-28,20.3v-4.8Z",
    fill: "#064b93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12",
    d: "M27.3.712.7,19.912v-3.9L22.5.712h4.8m2.1-.7H22.2L0,15.612v5.7Z",
    fill: "#03968f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13",
    d: "M.3,6.812,9.5.312h6.2L.3,11.512Z",
    fill: "#064b93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_14",
    d: "M14.6.712.7,10.812v-3.8L9.6.712h5m2.2-.7H9.4L0,6.612v5.5Z",
    fill: "#03968f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_15",
    d: "M38.5,9.659l-1.8,5.7-1.1-1.4-.6.5-9.1,7.2-.1-.1-3.6-4.1-.6.4-10,7-.4-.6-1.5-2-.6.4-4.1,3H0v-.8l10.4-7.2h0l1.7,2.2.4.5,10.7-7.5,2.9,3.6.4.4h0l7.3-5.2-1.4-1.8h0l6.1-.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16",
    d: "M32.5,9.559H32l.3.5h0l1.1,1.4-6.9,5-3.2-4-10.8,7.5-1.9-2.5-.1-.2L0,24.559v.6l10.4-7.2,2.1,2.7,10.7-7.5,3.2,4,7.7-5.5-1.2-1.6,5.3-.1-1.6,4.9-1-1.2-9.6,7.6-3.6-4.1-10.5,7.4-1.9-2.6-4.8,3.6H0v.5H5.2l4.5-3.3,1.9,2.6,10.5-7.4,3.4,3.9.2.2,9.7-7.6,1.2,1.6,2.1-6.4-6.2-.1Z",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_47",
    "data-name": "Groupe 47",
    transform: "translate(-76)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1376",
    "data-name": "Trac\\xE9 1376",
    d: "M145.628,13.044a7.275,7.275,0,0,1,2.573,5.907,7.274,7.274,0,0,1-2.573,5.907A10.7,10.7,0,0,1,138.566,27h-5.709v7h-3.3V10.9h9.009a10.7,10.7,0,0,1,7.062,2.145ZM143.252,22.8a4.662,4.662,0,0,0,1.649-3.845,4.664,4.664,0,0,0-1.649-3.845,7.449,7.449,0,0,0-4.785-1.336h-5.61V24.131h5.61a7.447,7.447,0,0,0,4.785-1.336Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1377",
    "data-name": "Trac\\xE9 1377",
    d: "M157.77,17.136a8.878,8.878,0,0,1,3.928-.792v3.069a6.446,6.446,0,0,0-.727-.033,5.333,5.333,0,0,0-4.042,1.534,6.076,6.076,0,0,0-1.469,4.373V34h-3.168V16.509h3.036v2.938a5.41,5.41,0,0,1,2.441-2.311Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1378",
    "data-name": "Trac\\xE9 1378",
    d: "M181.168,26.31h-14.19a5.494,5.494,0,0,0,2.029,3.713,6.619,6.619,0,0,0,4.307,1.4,6.488,6.488,0,0,0,5.049-2.111l1.749,2.046a7.647,7.647,0,0,1-2.953,2.111,11.127,11.127,0,0,1-8.86-.412,8.1,8.1,0,0,1-3.316-3.185,9.13,9.13,0,0,1-1.172-4.62,9.275,9.275,0,0,1,1.139-4.587,8.157,8.157,0,0,1,3.135-3.185,8.93,8.93,0,0,1,4.505-1.139,8.752,8.752,0,0,1,4.472,1.139,7.987,7.987,0,0,1,3.068,3.185,9.7,9.7,0,0,1,1.1,4.686,9.277,9.277,0,0,1-.065.957ZM168.776,20.4a5.588,5.588,0,0,0-1.8,3.63H178.2a5.62,5.62,0,0,0-1.8-3.613,5.906,5.906,0,0,0-7.624-.016Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1379",
    "data-name": "Trac\\xE9 1379",
    d: "M202.123,9.513V34h-3.036V31.227a6.861,6.861,0,0,1-2.673,2.212,8.286,8.286,0,0,1-3.564.759,9.193,9.193,0,0,1-4.554-1.122,8.037,8.037,0,0,1-3.151-3.151,9.383,9.383,0,0,1-1.139-4.67,9.286,9.286,0,0,1,1.139-4.653,8.082,8.082,0,0,1,3.151-3.135,9.2,9.2,0,0,1,4.554-1.122,8.379,8.379,0,0,1,3.465.71,6.724,6.724,0,0,1,2.641,2.1V9.513h3.168ZM196.117,30.65a5.439,5.439,0,0,0,2.111-2.178,6.655,6.655,0,0,0,.76-3.218,6.658,6.658,0,0,0-.76-3.218,5.339,5.339,0,0,0-2.111-2.161,6.354,6.354,0,0,0-6.023,0,5.47,5.47,0,0,0-2.112,2.161,6.532,6.532,0,0,0-.775,3.218,6.54,6.54,0,0,0,.775,3.218,5.581,5.581,0,0,0,2.112,2.178,6.239,6.239,0,0,0,6.023,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1380",
    "data-name": "Trac\\xE9 1380",
    d: "M208.179,12.549a1.945,1.945,0,0,1-.611-1.452,2,2,0,0,1,.611-1.468,2.079,2.079,0,0,1,1.534-.611,2.144,2.144,0,0,1,1.534.578,1.9,1.9,0,0,1,.61,1.436,2.038,2.038,0,0,1-.61,1.5,2.081,2.081,0,0,1-1.534.61A2.106,2.106,0,0,1,208.179,12.549Zm-.05,3.96H211.3V34h-3.168V16.509Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1381",
    "data-name": "Trac\\xE9 1381",
    d: "M220.189,33.042a8.456,8.456,0,0,1-3.283-3.185,8.943,8.943,0,0,1-1.188-4.6,8.946,8.946,0,0,1,1.188-4.6,8.345,8.345,0,0,1,3.283-3.168,9.829,9.829,0,0,1,4.769-1.139,9.155,9.155,0,0,1,4.241.957,6.827,6.827,0,0,1,2.887,2.772l-2.408,1.551a5.384,5.384,0,0,0-2.047-1.881,5.833,5.833,0,0,0-2.706-.627,6.252,6.252,0,0,0-3.085.759,5.429,5.429,0,0,0-2.146,2.161,6.543,6.543,0,0,0-.775,3.218,6.623,6.623,0,0,0,.775,3.251,5.41,5.41,0,0,0,2.146,2.161,6.241,6.241,0,0,0,3.085.759,5.833,5.833,0,0,0,2.706-.627,5.392,5.392,0,0,0,2.047-1.881l2.408,1.518a6.914,6.914,0,0,1-2.887,2.789,9.028,9.028,0,0,1-4.241.974,9.721,9.721,0,0,1-4.769-1.155Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1382",
    "data-name": "Trac\\xE9 1382",
    d: "M246.243,32.976a4.727,4.727,0,0,1-1.716.908,7.177,7.177,0,0,1-2.112.313,5.607,5.607,0,0,1-4.092-1.419,5.416,5.416,0,0,1-1.452-4.06v-9.6H233.9V16.508h2.97V12.68h3.168v3.828h5.016v2.607h-5.016v9.471a3.072,3.072,0,0,0,.709,2.178,2.641,2.641,0,0,0,2.03.76,3.818,3.818,0,0,0,2.475-.825l.99,2.276Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHbdocpredict);
export default __webpack_public_path__ + "static/media/hbdocpredict.400ece1eb72d55c85b2461947686e7b1.svg";
export { ForwardRef as ReactComponent };